/* W-03 timeline: a Gantt of lanes over the trip's days, then bookings and days. */
.page {
  padding-bottom: var(--dimension-space-8);
}
.pad {
  padding: var(--dimension-space-4) var(--dimension-space-5);
}
.muted {
  color: var(--color-text-secondary);
}
.top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: end;
  gap: var(--dimension-space-4);
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.title {
  margin: 0;
}
.stats {
  display: flex;
  gap: var(--dimension-space-6);
  margin: 0;
}
.stats dt {
  color: var(--color-text-tertiary);
}
.stats dd {
  margin: 0;
}
.scroll {
  overflow-x: auto;
  padding: 0 var(--dimension-space-5);
}
/* The whole trip across the page; a long trip scrolls once a day would be under 72px. */
.gantt {
  min-width: 100%;
}
.titleLine {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--dimension-space-4);
}
.bracket {
  color: var(--color-text-tertiary);
  font-weight: 400;
  margin: 0 var(--dimension-space-1);
}
.bracket:first-child {
  margin-left: 0;
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-2);
}
.moveLine {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* Today's column runs down every lane (W-03). */
.todayCell {
  background: color-mix(in srgb, var(--color-surface-signal) 30%, transparent);
  border-left: var(--dimension-line-control) solid var(--color-text-primary);
}
.todayLabel {
  color: var(--color-text-primary);
  font-weight: 700;
}
.lane {
  display: grid;
  align-items: center;
  min-height: 52px;
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.axis {
  align-items: end;
  border-bottom: var(--dimension-line-hairline) solid var(--color-text-primary);
}
.dayHead {
  min-width: 0;
  display: grid;
  gap: 2px;
  padding: 0 0 var(--dimension-space-1) var(--dimension-space-2);
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.flag {
  justify-self: start;
  padding: 1px var(--dimension-space-1);
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.today {
  background: color-mix(in srgb, var(--color-surface-signal) 30%, transparent);
  border-left: var(--dimension-line-control) solid var(--color-text-primary);
}
.laneName {
  color: var(--color-text-tertiary);
}
.bar {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  height: 30px;
  margin: 0 1px;
  padding: 0 var(--dimension-space-2);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
}
.dest {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.dim {
  opacity: 0.7;
}
.stay {
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
  color: var(--color-text-primary);
}
.cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: 100%;
  min-height: 52px;
  padding: var(--dimension-space-1) var(--dimension-space-2);
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
  color: inherit;
  text-decoration: none;
}
.move {
  display: grid;
  overflow: hidden;
  border-left: var(--dimension-line-control) solid var(--color-text-primary);
  padding-left: var(--dimension-space-1);
}
.dots {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}
.dots i {
  width: 8px;
  height: 8px;
  border: 1.5px solid;
}
.spend {
  min-height: 72px;
}
.spend .cell {
  justify-content: flex-end;
  padding-bottom: 0;
}
.spendBar {
  display: block;
  width: 60%;
  min-height: 1px;
  background: var(--color-text-primary);
}
.todayBar {
  background: var(--color-surface-signal);
  box-shadow: inset 0 0 0 1px var(--color-text-primary);
}
.future {
  background: var(--color-border-hairline);
}
.legend {
  margin: var(--dimension-space-2) 0 0;
}
.lower {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: var(--dimension-space-5) var(--dimension-space-5) 0;
  border-top: var(--dimension-line-hairline) solid var(--color-text-primary);
}
.lower section + section {
  border-left: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.head {
  margin: 0;
  padding: var(--dimension-space-3) var(--dimension-space-4);
}
.list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.list li {
  display: grid;
  grid-template-columns: 48px 1fr auto auto;
  align-items: center;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-2) var(--dimension-space-4);
  border-top: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.todayRow {
  background: color-mix(in srgb, var(--color-surface-signal) 30%, transparent);
}
.dayLink {
  color: var(--color-text-primary);
  text-decoration: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dayLink:hover {
  text-decoration: underline;
}
.num {
  text-align: right;
}
@media (max-width: 899px) {
  .lower {
    grid-template-columns: 1fr;
  }
  .lower section + section {
    border-left: 0;
  }
}
